function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.587,
    height: 12.502,
    viewBox: "0 0 7.587 12.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 82",
    d: "m12.393 130.881 5.564-5.564a.687.687 0 0 0 0-.972l-.649-.649a.687.687 0 0 0-.971 0l-4.43 4.41-4.43-4.41a.687.687 0 0 0-.971 0l-.649.649a.687.687 0 0 0 0 .972l5.564 5.564a.687.687 0 0 0 .972 0z",
    transform: "rotate(90 68.369 62.713)",
    style: {
      stroke: "#000",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.6b3ba0029d167361a47bc1cb937da40e.svg";
export { ForwardRef as ReactComponent };